import {useCallback, useRef} from "react";
import {config} from "../config";

declare global {
  interface Window {
    claspo?: (...args: any[]) => void;
  }
}

export function useClaspoWidget() {
  const scriptLoaded = useRef(false);
  
  const loadClaspo = useCallback((enabled: boolean) => {
    if (!enabled || scriptLoaded.current) return;
    if (!config.claspoId) {
      console.warn("Claspo ID is not configured.");
      return;
    }
    
    const claspoId = config.claspoId;
    const script = document.createElement("script");
    script.src = `https://scripts.claspo.io/scripts/${claspoId}.js`;
    script.async = true;
    
    script.onload = () => {
      scriptLoaded.current = true;
      if (typeof window.claspo === "function") {
        try {
          window.claspo("init");
          console.log("Claspo initialized ✅");
        } catch (error) {
          console.error("Error initializing Claspo:", error);
        }
      } else {
        console.warn("Claspo script loaded but window.claspo is not available.");
      }
    };
    
    document.body.appendChild(script);
  }, []);
  
  return { loadClaspo };
}
